<template>
  <div class="chat-window">
    <div class="chat-title">编辑</div>
    <div class="chat-container">
      <el-form
        :model="model"
        label-position="top"
        size="small"
        class="content"
      >
        <el-form-item label="蜘客标题">
          <el-input
            v-model="model.title"
            class="input-style"
            placeholder="请输入标题……"
          ></el-input>
        </el-form-item>
        <el-form-item label="蜘客文章图片封面">
          <!-- <div class="uploadExplain">
            PNG 格式，180 × 180像素，大小不超过500kb
          </div> -->
          <div class="uploadExplain">
            jpg/png格式，3000 ×3000像素，大小不超过5MB
          </div>
          <!-- 上传图片 -->
          <div class="avatar-uploader-container">
            <el-upload
              class="avatar-uploader"
              :action="host"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :data="ossForm"
              :multiple="false"
            >
              <img
                v-if="imageUrl"
                :src="imageUrl"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
            <div
              v-if="imageUrl"
              class="avatar-delete-btn"
              @click.stop="deleteAvatar"
            >×</div>
          </div>
        </el-form-item>
        <el-form-item label="正文" class="titleTopBox">
          <div id="fwb">

          </div>
          <!-- <tinymce
            class="tinymce_info"
            v-model="model.content"
            ref="content"
          ></tinymce> -->
        </el-form-item>
      </el-form>
      <div class="submit">
        <div class="submit-button">
          <el-button
            round
            size="small"
            @click="nextStep"
            :disabled="!model.title || !model.headImageUrl"
            :class="{ 'activeBlueBg': model.title && model.headImageUrl }"
            class="next-button"
          >下一步</el-button>
          <el-button
            round
            size="small"
            @click="handleSubmit(0)"
          >存草稿箱</el-button>

        </div>
        <div class="submit-remark">
          <p>1、稿件发布至蜘信手机端蜘客空间。</p>
          <p>2、已发稿件自动保存至电脑版“已发稿件“</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import api from "@/api/api";
import E from 'wangeditor'
import axios from "axios"
export default {
  // 编辑
  name: "editDetail",
  components: {
    Tinymce,
  },
  data() {
    return {
      model: {
        title: "", //标题 必填
        content: "", //内容
        status: null, //状态 1发布 0草稿
        editType: 1, //编辑类型 0手机端 1电脑端
        headImageUrl: "", //封面 必填
      },
      imageUrl: "",
      ossForm: {}, //oss配置
      host: "", //上传地址
      saveStatus: 0, //设置一个值 0原本的保存 1已发稿件修改的保存 草稿箱的编辑
      id: "", //修改编辑的id
      fromId:'',//来自那个修改
      editor:{},//富文本对象
    };
  },
  created() {
  },
  mounted(){
    this.initWangeditor()
  },
  methods: {
    //下一步
    nextStep() {
      console.log('editDetail nextStep called');
      if (this.model.title == "") {
        this.$message({
          message: "请填写文章标题",
          type: "warning",
        });
        return;
      }
      if (this.model.headImageUrl == "") {
        this.$message({
          message: "请先上传封面图",
          type: "warning",
        });
        return;
      }
      // 关键修复：在下一步之前获取编辑器内容
      this.model.content = this.editor.txt.html();
      console.log('获取编辑器内容:', this.model.content);
      
      // 确保status有值
      if (this.model.status === null) {
        this.model.status = 1; // 默认设置为发布状态
      }
      
      console.log('editDetail nextStep emitting event with model:', this.model);
      // 传递id和saveStatus，用于区分编辑和新增
      this.$emit('nextStep', { model: this.model, id: this.id, saveStatus: this.saveStatus });
    },
    //初始化wangeditor富文本
    initWangeditor() {
      this.$nextTick(() => {
        try {
          const editorContainer = document.getElementById('fwb');
          if (!editorContainer) {
            console.error('WangEditor容器未找到！');
            return;
          }

          // 清理旧实例
          if (this.editor) {
            try {
              this.editor.destroy();
            } catch (e) {
              console.log('销毁旧实例失败:', e);
            }
          }

          // 创建新实例
          this.editor = new E(editorContainer);
          
          // 恢复完整的工具栏配置
          this.editor.config.menus = [
            'head',
            'bold',
            'fontSize',
            'fontName',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'lineHeight',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            'video',
            'table',
            'code',
            'splitLine',
            'undo',
            'redo'
          ];

          // 恢复原有配置
          this.editor.config.height = 400;
          this.editor.config.zIndex = 100;
          this.editor.config.placeholder = '请输入正文内容...';

          // 配置图片上传
          this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
            resultFiles.forEach(item=>{
              //验证图片格式
              const isJpgPng = item.type === "image/jpeg" || item.type === "image/png";
              //验证图片大小（5MB）
              const isSize = item.size / (1024 * 1024) < 5;
              if (!isJpgPng) {
                alert("上传图片只能是 jpg/png 格式!");
                return;
              }
              if (!isSize) {
                alert("上传图片大小不能超过 5MB!");
                return;
              }
              //验证图片像素
              const img = new Image();
              img.onload = () => {
                const { width, height } = img;
                if (width > 3000 || height > 3000) {
                  alert("上传图片像素不能超过 3000 × 3000!");
                  return;
                }
                api.upload
                  .policy()
                  .then((res) => {
                    let host = res.result.host;
                    let OSSAccessKeyId = res.result.accessKeyId;
                    let callback = res.result.callback;
                    let key = res.result.dir + "/" + item.lastModified + item.name;
                    let policy = res.result.policy;
                    let signature = res.result.signature;
                    let success_action_status = 200;
                    let formData = new FormData();
                    formData.append('OSSAccessKeyId', OSSAccessKeyId);
                    formData.append('callback', callback);
                    formData.append('key', key);
                    formData.append('policy', policy);
                    formData.append('signature', signature);
                    formData.append('success_action_status', success_action_status);
                    formData.append('file', item);
                    axios.post(host,formData).then(ress=>{
                      console.log("图片===",ress)
                      insertImgFn(ress.data.result.filename)
                    })
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              };
              img.onerror = () => {
                alert("图片加载失败，请重新选择!");
              };
              img.src = URL.createObjectURL(item);
            });
          };

          // 创建编辑器
          this.editor.create();
          
          // 保留样式修复（只针对粗体和斜体）
          const fixStyle = document.createElement('style');
          fixStyle.textContent = `
            /* 仅修复粗体和斜体样式 */
            .w-e-text-container strong,
            .w-e-text-container b {
              font-weight: bold !important;
            }
            
            .w-e-text-container em,
            .w-e-text-container i {
              font-style: italic !important;
            }
          `;
          document.head.appendChild(fixStyle);

          console.log('WangEditor初始化成功，所有功能已恢复');

        } catch (error) {
          console.error('WangEditor初始化失败:', error);
        }
      });
    },
    // 确定 发布文章
    handleSubmit(id) {
      //id 0草稿箱 1发布
      this.model.status = id;
      if (this.model.title == "") {
        this.$message({
          message: "请填写文章标题",
          type: "warning",
        });
        return;
      }
      if (this.model.headImageUrl == "") {
        this.$message({
          message: "请先上传封面图",
          type: "warning",
        });
        return;
      }
      if (this.saveStatus == 0) {
        this.model.content = this.editor.txt.html();
        api.article.release(this.model).then((res) => {
          if (id == 0) {
            this.$message({
              message: "已保存到草稿箱",
              type: "success",
            });
          } else {
            this.$message({
              message: "发布成功",
              type: "success",
            });
            
          }
          this.getArticleList();
          this.clearModel();
          this.imageUrl = "";
        });
      }
      // this.model.content = this.editor.txt.html();
      if (this.saveStatus == 1) {
        api.article.editArticle(this.id, this.model).then((res) => {
         
            console.log(res);
            if (id == 0) {
              this.$message({
                message: "已保存到草稿箱",
                type: "success",
              });
              
            } else {
              this.$message({
                message: "发布成功",
                type: "success",
              });
             
            }
            this.getArticleList();
            this.clearModel();
            this.imageUrl = "";
        });
      }
    },
    //上传图片成功后
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      // console.log("====",res.result)
      this.model.headImageUrl = res.result.filename;
    },
    //上传图片前
    beforeAvatarUpload(file) {
      //验证图片格式
      const isJpgPng = file.type === "image/jpeg" || file.type === "image/png";
      //验证图片大小（5MB）
      const isSize = file.size / (1024 * 1024) < 5;
      //验证图片像素
      return new Promise((resolve, reject) => {
        if (!isJpgPng) {
          this.$message.error("上传图片只能是 jpg/png 格式!");
          reject(false);
          return;
        }
        if (!isSize) {
          this.$message.error("上传图片大小不能超过 5MB!");
          reject(false);
          return;
        }
        //验证图片像素
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;
          if (width > 3000 || height > 3000) {
            this.$message.error("上传图片像素不能超过 3000 × 3000!");
            reject(false);
          } else {
            //promise 构造oss参数
            api.upload
              .policy()
              .then((res) => {
                this.host = res.result.host;
                this.ossForm.OSSAccessKeyId = res.result.accessKeyId;
                this.ossForm.callback = res.result.callback;
                this.ossForm.key = res.result.dir + "/" + file.uid + file.name;
                this.ossForm.policy = res.result.policy;
                this.ossForm.signature = res.result.signature;
                this.ossForm.success_action_status = 200;
                resolve(true);
              })
              .catch((err) => {
                console.log(err);
                reject(false);
              });
          }
        };
        img.onerror = () => {
          this.$message.error("图片加载失败，请重新选择!");
          reject(false);
        };
        img.src = URL.createObjectURL(file);
      });
    },
    //清空model表单
    clearModel() {
      this.model.title = "";
      this.model.content = "";
      this.model.title = "";
      this.model.status = null;
      this.model.editType = 1;
      this.model.headImageUrl = "";
      // this.$refs.content.setContent("");
      this.editor.txt.clear()
    },
    //初始化更新数量
    getArticleList() {
      // 使用getArticleTypes接口获取公开和私密稿件数量
      api.article
        .getArticleTypes()
        .then((res) => {
          // 处理接口返回的数据结构
          if (res.result && res.result.length > 0) {
            res.result.forEach(item => {
              if (item.typeName === '公开文章') {
                this.$emit("alreadyUpdateTotal", item.articleCount || 0);
              } else if (item.typeName === '私密文章') {
                this.$emit("privateUpdateTotal", item.articleCount || 0);
              }
            });
          }
          setTimeout(()=>{
            if(this.fromId==1){
            this.$emit("editChangeCurrent",1);
          }
          if(this.fromId==2){
            this.$emit("editChangeCurrent",2);
          }
          },500)
        })
        .catch((err) => {
          console.log(err);
        });
      
      // 草稿箱数量
      api.article
        .articleList({ status: 0 })
        .then((res) => {
          this.$emit("draftsUpdateTotal", res.result.total);
          setTimeout(()=>{
            if(this.fromId==1){
            this.$emit("editChangeCurrent",1);
          }
          if(this.fromId==2){
            this.$emit("editChangeCurrent",2);
          }
          },500)
        })
        .catch((err) => {
          console.log(err);
        });
        
    },
    //修改文章
    edit(item) { 
      let editMsg = JSON.parse(item);
      console.log("======编辑文章数据:", editMsg);
      this.model.title = editMsg.title;
      this.model.status = null;
      this.model.editType = 1;
      this.model.headImageUrl = editMsg.headImageUrl;
      this.model.keyWord = editMsg.keyWord; // 保存标签信息
      this.model.visibleRange = editMsg.visibleRange; // 保存可见范围
      this.model.priceType = editMsg.priceType; // 保存价格类型
      this.model.price = editMsg.price; // 保存价格
      this.imageUrl = editMsg.headImageUrl;
      // this.$refs.content.setContent(editMsg.content);
      this.editor.txt.html(editMsg.content)
      console.log("======修改", editMsg.content);
      this.saveStatus = 1;
      this.id = editMsg.id;
      this.fromId = editMsg.fromId
      this.model.content = this.editor.txt.html();
      console.log("======model数据:", this.model);
    },
    // 设置文章数据（用于返回上一步时恢复数据）
    setArticleData(data) {
      console.log('editDetail setArticleData called with data:', data);
      if (data) {
        // 更新 model 数据，保留所有字段（包括价格、标签、可见范围）
        this.model = {
          title: data.title || '',
          content: data.content || '',
          status: data.status || 1,
          editType: data.editType || 1,
          headImageUrl: data.headImageUrl || '',
          keyWord: data.keyWord,
          visibleRange: data.visibleRange,
          priceType: data.priceType,
          price: data.price,
        };
        
        // 更新封面图片
        if (data.headImageUrl) {
          this.imageUrl = data.headImageUrl;
        }
        
        // 更新富文本编辑器内容
        if (data.content) {
          this.editor.txt.html(data.content);
        }
        
        console.log('editDetail data restored successfully, priceType:', this.model.priceType, 'price:', this.model.price);
      }
    },

    //删除封面图片
    deleteAvatar() {
      this.imageUrl = "";
      this.model.headImageUrl = "";
    },
    //获取oss上传成功的回调
    // getOssCallBack(){
    //   ossApi.callback().then(res=>{
    //     console.log(res)
    //   })
    // },
  },
};
</script>

<style scoped>



.chat-window {
  min-width: 506px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-left: 1px solid #dcdfe6;
  position: relative;
}
.chat-window .chat-title {
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 18px;
  color: #313233;
  letter-spacing: 2px;
  padding: 0 20px;
  background: #ffffff;
  box-sizing: border-box;
  border-bottom: 1px solid #dcdfe6;
  position: relative;
}
.chat-window .chat-container {
  height: calc(100% - 128px);
  width: 100%;
  /* padding-top: 20px; */
  box-sizing: border-box;
  /* border-bottom: 1px solid #dcdfe6; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* overflow-x: hidden;
  overflow-y: auto; */
  position: relative;
}
.chat-container .content {
  width: 100%;
  height: calc(100% - 10px);
  padding: 20px 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}
.content .el-form-item:nth-child(1) {
  padding-left: 20px;
}
.content .el-form-item:nth-child(2) {
  margin-bottom: 0;
}
.content .el-form-item:nth-child(2) >>> .el-form-item__label {
  margin-left: 20px;
}
.tinymce_info {
  height: 300px !important;
}
.tinymce-container >>> .mce-tinymce {
  width: 100% !important;
  height: 100% !important;
}

.el-form--label-top >>> .el-form-item__label {
  padding: 0;
  font-size: 16px;
  color: #313233;
}
.submit {
  width: 100%;
  height: 68px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  z-index: 200;
  background: #ffffff;
  border-top: 1px solid #dcdfe6;
}
.submit-button {
  display: flex;
  flex-direction: row;
}
.submit button {
  width: 84px;
  height: 28px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.submit-remark {
  font-size: 12px;
  color: #7b7d80;
}
.submit-remark p:nth-child(1) {
  margin-bottom: 4px;
}
.input-style /deep/ input {
  border: none !important;
  padding-left: 0;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}
.avatar {
  width: 78px;
  height: 78px;
  display: block;
}
.avatar-uploader-container {
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
  display: inline-block;
}
.avatar-delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  text-align: center;
  z-index: 100;
  background-color: rgba(255, 73, 73, 0.9);
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-delete-btn:hover {
  background-color: rgba(255, 73, 73, 1);
  transform: scale(1.1);
}
.uploadExplain {
  font-size: 12px;
  color: #999;
  margin-left: 20px;
  margin-top: -10px;
}
.titleTopBox /deep/ .el-form-item__label{
  padding-left: 20px;
}
.titleTopBox /deep/ .el-form-item__content{
  padding: 0 20px;
}
.next-button {
  width: 70px;
  height: 28px;
  background: rgba(77, 180, 212, 0.5);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: none;
  cursor: pointer;
}
.activeBlueBg {
  background: #4db4d4;
}
</style>